import React, { useContext, useEffect, useState } from 'react';

import { Container, Grid, LinearProgress } from '@mui/material';
import { PageHeader } from '../../common';
import { FetchContext, NavContext, NavRoutes } from '../../contexts';
import { TipiContattiContext, TipiContattiProvider } from './TipiContattiContext';
import { TipiList } from './components';

const PageContent = (props) => {

    const {
        user
    } = useContext(FetchContext);

    const {
        addBreadcrumbToken,
        setBread,
        navigateTo
    } = useContext(NavContext);

    const {

        state,
        setState,

        isLoadingTipiContatti,
        getTipiContattiAsync,

        isDeletingTipoContatto,
        deleteTipoContattoAsync,

    } = useContext(TipiContattiContext)

    const {
        deleteTipoContatto
    } = state;

    const loadMoreHandler = async (pageIndex, pageSize, searchText, valid) => {
        await getTipiContattiAsync(pageIndex, pageSize, searchText, valid);
    }

    const [searchText, setSearchText] = useState("");
    const searchClickHandler = async (searchText) => {
        setSearchText(searchText);
    };

    const tipiListActionClickHandler = async (action, data) => {
        switch (action) {
            case "Add":
                window.open(NavRoutes.TipoContattoAdd, "_blank").focus();
                break;
            case "Delete":
                deleteTipoContattoAsync(data.id);
                break;
            default:
                break;
        }
    }

    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        setIsLoading(isLoadingTipiContatti || isDeletingTipoContatto);
    }, [isLoadingTipiContatti, isDeletingTipoContatto]);

    useEffect(() => {
        if (user && deleteTipoContatto)
            deleteTipoContattoAsync(deleteTipoContatto.id);
        // setOpenDeleteTipoContattoDialog(true);
    }, [deleteTipoContatto, user])

    useEffect(() => {
        if (user)
            addBreadcrumbToken("Tipi attributo");
    }, [user]);

    const [openDeleteTipoContattoDialog, setOpenDeleteTipoContattoDialog] = useState(false);

    if (!user)
        return <Container>
            <LinearProgress />
        </Container>

    return (
        <>
            <Container>
                {isLoading && <LinearProgress />}
                <Grid container>
                    <Grid item xs={12}>
                        <PageHeader
                            disabled={isLoading}
                            search
                            onSearchClick={searchClickHandler}
                            title="Tipi attributo"
                            subtitle="Gestisci i tipi attributo" />
                    </Grid>
                    <Grid item xs={12}>
                        <TipiList
                            searchText={searchText}
                            onActionClick={tipiListActionClickHandler}
                            itemsPerPage={25}
                            onLoadMore={loadMoreHandler}
                            disabled={isLoading} />
                    </Grid>
                </Grid>
            </Container>
            {/* <ActionDialog
                title="Disabilitazione competenza"
                content={`Sei sicuro di disabilitare la "${deleteTipoContatto?.nome}"`}
                open={openDeleteTipoContattoDialog}
                handleClose={() => {
                    setOpenDeleteTipoContattoDialog(false);
                    setState({ deleteTipoContatto: null });
                }}
                handleSubmit={() => {
                    console.log(deleteTipoContatto);
                    deleteTipoContattoAsync(deleteTipoContatto.id);
                    setOpenDeleteTipoContattoDialog(false);
                    setState({ deleteTipoContatto: null });
                }}
            /> */}
        </>
    );
}

export const TipiContattiPage = () => {

    return (
        <TipiContattiProvider>
            <PageContent />
        </TipiContattiProvider>
    );
}